// Estilos compartidos para el dashboard
export const montserratStyle = {
  fontFamily: 'Montserrat, sans-serif',
}

// Variantes del estilo Montserrat
export const montserratBoldStyle = {
  ...montserratStyle,
  fontWeight: 700,
}

export const montserratLightStyle = {
  ...montserratStyle,
  fontWeight: 400,
}

// Estilo para títulos
export const titleStyle = {
  ...montserratBoldStyle,
  fontSize: '1.125rem', // 18px
  lineHeight: 1.5,
}

// Estilo para subtítulos
export const subtitleStyle = {
  ...montserratStyle,
  fontSize: '1rem', // 16px
  lineHeight: 1.4,
}

// Estilo para texto de cuerpo
export const bodyStyle = {
  ...montserratStyle,
  fontSize: '0.875rem', // 14px
  lineHeight: 1.3,
}

export const tableHeaderStyle = (index?: number) => ({
  border: 'none',
  padding: '12px',
  fontSize: '14px',
  fontWeight: 'bold' as const,
  backgroundColor: index === 0 ? '#26342E' : '#7CA982',
  color: 'white',
  ...montserratStyle,
})

export const tableSubHeaderStyle = {
  border: 'none',
  padding: '8px 16px',
  fontSize: '14px',
  fontWeight: 'bold' as const,
  color: '#4B5563',
  textAlign: 'center' as const,
  ...montserratStyle,
}

export const tableCellStyle = {
  border: 'none',
  padding: '12px',
  fontSize: '14px',
  color: '#4B5563',
  ...montserratStyle,
}

export const tablePaginationStyle = (isDefault = true) => ({
  border: 'none',
  background: 'none',
  cursor: isDefault ? 'default' : 'pointer',
  color: isDefault ? '#9CA3AF' : '#374151',
  padding: '4px',
  display: 'flex',
  alignItems: 'center',
})
